import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function scrollToAccordion() {
    const accordions = document.querySelectorAll('.content-accordion .toggler');

    for (const accordion of accordions) {
        accordion.addEventListener('click', function () {
            if (!window.innerWidth < 992 || this.classList.contains('ui-state-active')) {
                return;
            }

            setTimeout(() => {
                ScrollUtil.scrollToTarget(this, -8, 600);
            }, 450);
        });
    }
}

onDomReady(() => {
    scrollToAccordion();
});
